<template>
  <router-link to="/" class="site-logo">
    <img src="@/assets/img/pilihlaptop-logo-min.png"
      alt="PilihLaptop.com"
      title="PilihLaptop.com"
      loading="lazy">
  </router-link>
</template>

<script>
export default {
  name: 'TheSiteLogo',
};
</script>

<style lang="scss" scoped>
  .site-logo {
    height: 3.75rem;
    width: 4.25rem;
    background-color: $black;
    padding: 0.5rem;

    @include media ("<=tablet") {
      width: 4rem;
      height: 60px;
    }
  }
</style>
